import { PropsWithChildren } from 'react';

import { XYChartData } from '../../types/xy-chart.js';

/**
 * The props for the `XYChart.Annotations` slot component.
 * @public
 */
export interface XYChartAnnotationsProps {
  /**
   * Data object for the xy chart.
   */
  data: XYChartData[];
  /**
   * Unique Id required to attach the annotations to its x-axis.
   */
  xAxisId: string;
  /**
   * Flag for showing/hiding track labels
   * @defaultValue false
   */
  showLabels?: boolean;
  /**
   * Amount of tracks visible without scrolling.
   * @defaultValue 3
   */
  fixedTracks?: number;
}

/**
 * The `Annotations` slot component for XYChart.
 * @public
 */
export const Annotations = (
  props: PropsWithChildren<XYChartAnnotationsProps>,
) => null;

Annotations['displayName'] = 'XYChart.Annotations';
